import { jsx as i, jsxs as E } from "react/jsx-runtime";
import { useState as g, useEffect as I, useCallback as s, useMemo as x } from "react";
import { z as e } from "zod";
import { withManagedProps as L } from "@made-people/managed-props";
import { withZod as N } from "@made-people/react-prop-guard";
import { motion as h } from "motion/react";
import { linksHorizontalImagesStyling as S } from "./index-blueprint.es.js";
import { useLink as A } from "@made-people/grease-link";
import { componentWrapperSchema as D, ComponentWrapper as F } from "@made-people/blueprint-component-wrapper";
import "@made-people/blueprint";
const M = e.object({
  categories: e.object({
    link: e.object({
      target: e.string().optional(),
      href: e.string()
    }).optional(),
    label: e.string(),
    image: e.object({
      src: e.string(),
      alt: e.string()
    })
  }).array(),
  variants: e.custom().optional(),
  layout: D.shape.layout.optional()
}), Q = L(
  "LinksHorizontalImages",
  N(
    M,
    ({ variants: z, categories: l, layout: H, ...$ }) => {
      const v = A(), n = S.styles(z), [o, m] = g(""), [r, p] = g(0), [c, j] = g(!1);
      I(() => {
        j(!0), p(window.innerWidth);
      }, []), s(() => {
        typeof window < "u" && p(window.innerWidth);
      }, []), I(() => {
        if (!c)
          return;
        const t = () => {
          p(window.innerWidth);
        };
        return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
      }, [c]);
      const d = x(() => {
        if (!c || r === 0)
          return {
            activeWidth: "88px",
            inactiveWidth: "88px"
          };
        const t = `${r / 4}px`, a = `${(r - r / 4) / (l.length - 1)}px`;
        return {
          activeWidth: t,
          inactiveWidth: a
        };
      }, [r, l.length, c]), w = s(
        (t) => ({
          maxWidth: o === t ? d.activeWidth : "88px",
          width: o === t ? d.activeWidth : d.inactiveWidth
        }),
        [o, d]
      ), W = s((t) => {
        m(t);
      }, []), f = s(() => {
        m("");
      }, []), b = s((t) => {
        m(t);
      }, []), C = x(
        () => l.map((t, a) => {
          var k;
          return /* @__PURE__ */ i(
            h.div,
            {
              className: n.itemWrapper,
              onHoverStart: () => W(t.label),
              onHoverEnd: f,
              onFocus: () => b(t.label),
              onBlur: f,
              animate: w(t.label),
              role: "button",
              tabIndex: 0,
              onKeyDown: (u) => {
                var y;
                (u.key === "Enter" || u.key === " ") && (u.preventDefault(), (y = t.link) != null && y.href && (window.location.href = t.link.href));
              },
              children: /* @__PURE__ */ E(
                v,
                {
                  href: ((k = t.link) == null ? void 0 : k.href) ?? "",
                  className: "block w-full h-full",
                  children: [
                    /* @__PURE__ */ i(
                      h.img,
                      {
                        src: t.image.src,
                        alt: t.image.alt,
                        loading: "eager",
                        className: n.image
                      },
                      `category-link-${a}`
                    ),
                    /* @__PURE__ */ i(
                      h.div,
                      {
                        className: n.titleWrapper,
                        children: /* @__PURE__ */ i(
                          "span",
                          {
                            "data-is-active": o === t.label ? "true" : "false",
                            className: n.title,
                            children: t.label
                          }
                        )
                      },
                      `${t.label}-${a}`
                    )
                  ]
                }
              )
            },
            `category-link-${a}-${t.label}`
          );
        }),
        [
          l,
          n,
          W,
          b,
          f,
          w,
          o,
          v
        ]
      );
      return /* @__PURE__ */ i(F, { layout: H, ...$, children: /* @__PURE__ */ i(h.section, { layout: !0, className: n.base, children: C }) });
    }
  )
);
export {
  Q as LinksHorizontalImages,
  M as LinksHorizontalImagesPropsSchema
};
//# sourceMappingURL=index.es.js.map
